import { subDays } from 'date-fns';
import { RemoteConfigUtils } from './RemoteConfigUtils';

/**
 * Number of days before a shift's start that Professional Pay is collected.
 *
 * Sourced from Firebase Remote Config (`CHARGE_TIMELINE_DAYS`). This window used
 * to be hardcoded to 28 days across several screens, which drifted out of sync
 * once the timeline became configurable.
 */
export function getChargeTimelineDays(): number {
  return RemoteConfigUtils.getChargeTimelineDays();
}

/**
 * The date Professional Pay will be charged for a shift starting at
 * `jobDateTime`: the shift start minus the configured charge-timeline window.
 *
 * Shared across the Confirm Candidate banner, Shift Details, and Job Details so
 * every surface displays the same charge date. Each caller formats the returned
 * `Date` with its own display format.
 *
 * @param jobDateTime - The shift start, as anything `new Date()` accepts.
 * @returns The charge date as a `Date` (callers format it themselves).
 */
export function getProfessionalPayChargeDate(jobDateTime: string | number | Date): Date {
  return subDays(new Date(jobDateTime), getChargeTimelineDays());
}
